// 您提供的排序函数，保持不变
// function sortMessages(messages) {
//    if (!Array.isArray(messages)) {
//       console.error("sortMessages: 传入的不是一个数组！");
//       return;
//    }
//    messages.sort((a, b) => {
//       if (a.messageSequence === b.messageSequence || a.messageSequence === 0 || b.messageSequence === 0) {
//          return new Date(a.messageTime) - new Date(b.messageTime);
//       } else {
//          return a.messageSequence - b.messageSequence;
//       }
//    });
// }

/**
 * 对消息进行排序。
 * 排序规则：
 * 1. 优先按照消息的日期（天）从早到晚排序。
 * 2. 如果日期是同一天，则再按照 messageSequence 从小到大进行排序。
 * @param {Array<Object>} messages - 消息对象数组
 */
function sortMessages(messages) {
   // 检查输入是否为数组，如果不是则报错返回
   if (!Array.isArray(messages)) {
      console.error("sortMessages: 传入的不是一个数组！");
      return;
   }
   messages.sort((a, b) => {
      const dateA = new Date(a.messageTime);
      const dateB = new Date(b.messageTime);
      // 创建只包含年、月、日的 Date 对象，用于纯日期比较
      // setHours(0, 0, 0, 0) 可以将时、分、秒、毫秒清零
      const dayA = new Date(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
      const dayB = new Date(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());

      // 比较日期
      const dayDifference = dayA - dayB;

      if (dayDifference !== 0) {
         // 如果日期不同，直接返回日期的比较结果
         return dayDifference;
      } else {
         // 如果日期相同，则按照 messageSequence 排序
         return a.messageSequence - b.messageSequence;
      }
   });
}

const state = {
   currentProduct: JSON.parse(sessionStorage.getItem('currentProduct')) || '',
   currentSendingToId: sessionStorage.getItem('currentSendingToId') || '',//当前聊天对象id
   currentConversationId: sessionStorage.getItem('currentConversationId') || '',//当前会话id
   ordinaryConversationData: [],
   isLoadMoreChatRecords: false,//本次加载是否为历史记录加载,如果是，则会话列表中不必修改最新一条记录
   moreChatRecordsPageNumberHistory: []
}


const mutations = {
   setCurrentProduct(state, payload) {
      state.currentProduct = payload;
      sessionStorage.setItem('currentProduct', JSON.stringify(payload));
   },
   setCurrentSendingToId(state, payload) {
      state.currentSendingToId = payload;
      sessionStorage.setItem('currentSendingToId', String(payload))
   },
   replaceOrSetCurrentConversationId(state, payload) {
      if (state.ordinaryConversationData.length > 0 && payload.toId) {
         const temp = state.ordinaryConversationData.find(item => item.conversationId.slice(item.conversationId.lastIndexOf('_') + 1) == payload.toId)
         if (temp) {
            temp.conversationId = payload.conversationId
         }
      }
      state.currentConversationId = payload.conversationId;
      sessionStorage.setItem('currentConversationId', String(payload.conversationId));
   },

   /**
    * @description 添加或更新聊天数据 (重构后版本)
    * @param {object} state - Vuex state
    * @param {object} payload - 消息对象或会话对象
    */
   setOrdinaryConversationData(state, payload) {
      // 检查是添加单个消息还是整个会话对象
      // 如果 payload 包含 chatData，说明是添加整个会话
      if (payload.chatData && Array.isArray(payload.chatData)) {
         const existingConversation = state.ordinaryConversationData.find(c => c.conversationId === payload.conversationId);
         if (!existingConversation) {
            state.ordinaryConversationData.push(payload);
            //排序会话
            state.ordinaryConversationData.forEach(element => {
               sortMessages(element.chatData);
            });
         }
         return; // 添加完整会话后直接返回
      }

      // --- 以下是处理单个消息的逻辑 ---
      //找出当前会话id
      const conversationIdToFind = state.isLoadMoreChatRecords ? state.currentConversationId : (state.ordinaryConversationData.find(c => String(c.conversationId).includes(payload.toId))?.conversationId || state.currentConversationId);
      //找出当前会话
      const conversation = state.ordinaryConversationData.find(c => c.conversationId === conversationIdToFind);

      if (conversation) {
         // 根据是否加载历史记录来决定插入方式
         if (state.isLoadMoreChatRecords) {
            // 加载更多历史记录时，在数组开头插入消息
            conversation.chatData.unshift(payload);
         } else {
            // 接收或发送新消息时，在数组末尾追加消息
            conversation.chatData.push(payload);
            // 只有新消息才更新 lastMessage
            conversation.lastMessage = payload.messageBody;
         }
      } else {
         // 如果会话不存在，则创建新会话 (适用于首次发送消息)
         console.log('未找到会话，正在创建新会话...');
         let initChatData = {
            conversationId: '1_' + payload.fromId + '_' + payload.toId,
            sequence: 0,
            readed_sequence: 0,
            toId: payload.toId,
            avatar: '/images/home/chat_avatar.jpg', // 可根据实际情况设置头像
            nickname: payload.toNickname,
            lastMessage: payload.messageBody,
            chatData: [payload] // 将当前消息作为第一条
         }
         state.ordinaryConversationData.push(initChatData);
      }
      //排序会话
      state.ordinaryConversationData.forEach(element => {
         sortMessages(element.chatData);
      });
   },

   updateOrdinaryConversationDataForSendStatus(state, payload) {
      const tempObject = state.ordinaryConversationData.find(item => item.conversationId === state.currentConversationId);
      if (!tempObject) {
         return;
      }
      const messageItem = tempObject.chatData.find(subItem => subItem.messageId == payload.messageId);
      if (messageItem && payload.status) {
         messageItem.status = payload.status;
      }
      if (messageItem && payload.messageSequence) {
         messageItem.messageSequence = payload.messageSequence;
      }
   },

   setIsLoadMoreChatRecords(state, payload) {
      state.isLoadMoreChatRecords = payload;
   },
   setMoreChatRecordsPageNumberHistory(state, payload) {
      const isExist = state.moreChatRecordsPageNumberHistory.some(item => item.conversationId === payload.conversationId);
      if (!isExist) {
         state.moreChatRecordsPageNumberHistory.push(payload);
      }
   },
   updateMoreChatRecordsPageNumberHistory(state, payload) {
      let tempObject = state.moreChatRecordsPageNumberHistory.find(item => item.conversationId == state.currentConversationId)
      if (tempObject) {
         tempObject[payload.objectKey] = payload.objectValue;
      }
   }
}

const actions = {}
const getters = {}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
   getters
}